import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d7cd1ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-swiper" }
const _hoisted_2 = { class: "swiper-container" }
const _hoisted_3 = ["onClick", "aria-label"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "controls" }
const _hoisted_6 = {
  key: 0,
  class: "indicators"
}
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Swiper"], {
        modules: [$setup.Autoplay],
        loop: $setup.hasMutlipleBanners,
        autoplay: $setup.hasMutlipleBanners ? $setup.autoplayOptions : false,
        allowTouchMove: $setup.hasMutlipleBanners,
        onSlideChange: $setup.onSlideChange,
        onSwiper: $setup.onSwiper,
        "aria-label": "이벤트 배너 슬라이드"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.campaignBannerImages, (image, index) => {
            return (_openBlock(), _createBlock($setup["SwiperSlide"], {
              key: index,
              role: "group",
              "aria-label": `배너 ${index + 1} / ${$setup.campaignBannerImages.length}`
            }, {
              default: _withCtx(() => [
                _createCommentVNode(" 클릭 가능한 이미지 => button 또는 a 태그로 대체 "),
                _createElementVNode("button", {
                  type: "button",
                  class: "banner-button",
                  onClick: ($event: any) => ($setup.onClickCampaignBannerImage(index)),
                  "aria-label": `관리자에서 등록한 ${$setup.getCampaignTitle(
              index
            )} 배너 자세히 보기`
                }, [
                  _createElementVNode("img", {
                    class: "banner-image",
                    src: image?.url,
                    "aria-hidden": "true"
                  }, null, 8 /* PROPS */, _hoisted_4)
                ], 8 /* PROPS */, _hoisted_3)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["aria-label"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modules", "loop", "autoplay", "allowTouchMove"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createCommentVNode(" 인디케이터 점들 "),
      ($setup.hasMutlipleBanners)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.campaignBannerImages, (image, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass(["indicator-dot", { active: $setup.currentIndex === index }]),
                "aria-label": `${index + 1}번째 슬라이드로 이동`,
                onClick: ($event: any) => ($setup.goToSlide(index))
              }, null, 10 /* CLASS, PROPS */, _hoisted_7))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 재생/일시정지 버튼 "),
      ($setup.hasMutlipleBanners)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "play-pause-btn",
            "aria-label": $setup.playButtonLabel,
            onClick: $setup.toggleAutoplay
          }, [
            ($setup.isPlaying)
              ? (_openBlock(), _createBlock($setup["InlineSvg"], {
                  key: 0,
                  class: "pause-icon",
                  src: require('@/assets/icons/pause.svg'),
                  alt: "일시정지"
                }, null, 8 /* PROPS */, ["src"]))
              : (_openBlock(), _createBlock($setup["InlineSvg"], {
                  key: 1,
                  class: "play-icon",
                  src: require('@/assets/icons/play.svg'),
                  alt: "재생"
                }, null, 8 /* PROPS */, ["src"]))
          ], 8 /* PROPS */, _hoisted_8))
        : _createCommentVNode("v-if", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowCampaignDetailSwiper,
        onBackHandler: () => $setup.toggleShowCampaignDetailSwiper(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["CampaignDetailSwiper"], {
            campaignImages: $setup.campaignCardNewsImages,
            campaignTitle: $setup.selectedCampaign?.name ?? '캠페인',
            altText: $setup.selectedCampaign?.altText,
            onOnClickCloseBtn: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowCampaignDetailSwiper(false)))
          }, null, 8 /* PROPS */, ["campaignImages", "campaignTitle", "altText"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]))
  ]))
}